import React from "react";

//mui
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";

//components
import CustomPopper from "./PopperComponent";

const Container = styled("div")(({ theme }) => ({
  "& .MuiMenuItem-root": {
    // background: "green",
  },
  "& .MuiAutocomplete-root": {
    background: "#FFFFFF",
  },
  "& .MuiAutocomplete-input": {
    height: "19px",
    fontSize: "14px",
    [theme.breakpoints.down("xl")]: {
      height: "17px",
      fontSize: "14px",
    },
  },
  "& .MuiInputLabel-root": {
    paddingBottom: "30px",
    fontSize: "15px",
    color: "#4F4F4F",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px",
    },
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    // paddingTop: "3px",
    // paddingBottom: "3px",
    "& .MuiChip-label": {
      fontSize: "12px",
      paddingTop: 0,
      paddingBottom: 0,
      [theme.breakpoints.down('xl')]: {
        fontSize: "11px",
      },
    },
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
      [theme.breakpoints.down('xl')]: {
        fontSize: "16px",
      },
    },
    "& .MuiAutocomplete-tagSizeMedium": {
      fontSize: "14px",
      // background: "cyan",
      [theme.breakpoints.down('xl')]: {
        fontSize: "12px",
      },
    }
  },
  "& .MuiAutocomplete-root .MuiAutocomplete-tag": {
    padding: 0,
  },
}));


const AutoCompleteMultiRole = ({
  options,
  value,
  variant = "outlined",
  onChange,
  disabled = false,
  label,
  text,
  ...restProps
}) => {
  return (
    <Container>
      <FormControl variant="outlined" sx={{ width: "100%", padding: 0 }}>
        <Autocomplete
          fullWidth
          options={options ? options : []}
          value={value}
          getOptionLabel={(option) => (option ? `${option.name}` : "")}
          onChange={(event, newValue) => onChange(newValue, text)}
          filterSelectedOptions
          renderInput={(params, index) => {
            const { InputProps, inputProps, ...renderProps } = params;
            inputProps.disabled = disabled;
            InputProps.endAdornment = disabled ? (
              <></>
            ) : (
              InputProps.endAdornment
            );
            return (
              <TextField
                key={index}
                {...renderProps}
                InputProps={{
                  ...InputProps,
                  // disableUnderline: variant === "standard" ? true : false,
                }}
                inputProps={inputProps}
                label={label}
                // className={classes.input}
                variant={variant}
                {...restProps}
              />
            );
          }}
          PopperComponent={CustomPopper}
        />
      </FormControl>
    </Container>
  );
};

export default AutoCompleteMultiRole;

